const PRODUCT_LINES = ['SuperImpact', 'SuperView', 'LINEToday']
export const ROUTE_PATH = {
  ROOT: '/',
  CALCULATION: `/calculation/${PRODUCT_LINES[0]}`,
  COMPARE: '/compare',
  GUIDE: {
    ROOT: '/guide/',
    PURPOSE: '/guide/purpose/',
    AUDIENCE: '/guide/audience/',
    NAME_PURPOSE: 'FromGuidePurpose',
    NAME_AUDIENCE: 'FromGuideAudience'
  },
  PRODUCT_LINES: PRODUCT_LINES
}
